import { createFileRoute } from '@tanstack/react-router'
import UpgradePlanPopup from '../../../containers/UpgradePlanPopup'

export const Route = createFileRoute('/_authenticated/upgrade/')({
  component: UpgradePlanPopup
})
